
import dayjs from 'dayjs'
import GoodsListPage from '@/components/GoodsListPage/index-new.vue'

export default {
    name: 'YesterdayDeal',
    components: {
        GoodsListPage
    },
    data () {
        return {
            loading: true,
            month: dayjs(new Date()).subtract(1, 'day').format('MM-DD'),
            week: dayjs(new Date()).subtract(1, 'day').format('dddd'),
            activeIndex: 0,
            allNumber: 0,
            tabsList: [],
            gameList: [],
            pageInfo: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            currentPage: 0, // 当前tabs页索引
            itemsPerPage: 6, // 定义当前使用tabs长度
            games: {}
        }
    },
    head () {
        return {
            title: '昨日成交-官方客服-盼之代售-手游网游账号买号卖号平台',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: '盼之代售，专业正规的游戏账号交易平台，中介担保签署正规法律合同。一手账号交易，专属客服1对1上架代售，提供包赔证明，永久包赔。'
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: '账号交易担保,游戏账号交易,盼之代售'
                }
            ]
        }
    },
    computed: {
        totalPages () {
            return Math.ceil(this.tabsList.length / this.itemsPerPage)
        },
        weekDate () {
            switch (this.week) {
            case 'Monday':
                return '周一'
                break
            case 'Tuesday':
                return '周二'
                break
            case 'Wednesday':
                return '周三'
                break
            case 'Thursday':
                return '周四'
                break
            case 'Friday':
                return '周五'
                break
            case 'Saturday':
                return '周六'
                break
            case 'Sunday':
                return '周日'
                break
            }
        }
    },
    mounted () {
        this.getTabsList()
    },
    methods: {
        // 获取昨日成交tabs数据
        async getTabsList () {
            const res = await this.$api.yesterdayDealGameAPI({ gameId: null })
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            if (res.data) {
                this.tabsList = res.data.games
                this.allNumber = res.data.totalTransaction

                if (this.$route.query.gameId) {
                    this.activeIndex = Number(this.$route.query.gameId)
                    setTimeout(() => {
                        const a = this.tabsList.findIndex(el => el.gameId === this.activeIndex)
                        this.currentPage = Math.ceil((a + 1) / this.itemsPerPage) - 1
                        this.scrollToPage(this.currentPage)
                    }, 300)
                    this.getGamesList(this.$route.query)
                } else {
                    this.activeIndex = this.tabsList[0].gameId
                    this.getGamesList(this.tabsList[0])
                }
            }
        },
        // 获取游戏列表数据
        async getGamesList (data) {
            this.games = data
            const par = {
                action: {
                    gameId: data.gameId
                },
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            const res = await this.$api.dealGameDetailAPI(par)
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            if (res.data) {
                const data = res.data
                this.gameList = data.records
                this.pageInfo.page = data.page
                this.pageInfo.total = Number(data.total)
            }
            this.loading = false
        },
        handleCurrentChange (v) {
            this.pageInfo.page = v
            this.getGamesList(this.games)
        },
        handleSizeChange (pageSize) {
            this.pageInfo.pageSize = pageSize
            this.pageInfo.page = 1
            this.getGamesList(this.games)
        },
        countStatus (val) {
            if (val < 0) { return 'https://oss.pzds.com/mobileV3/yesterday-deal_down.png' }
            else { return 'https://oss.pzds.com/mobileV3/yesterday-deal_up.png' }
        },
        // 根据tabs获取游戏列表数据
        geyCardGameList (data, index) {
            this.activeIndex = data.gameId
            this.getGamesList(data)
        },
        scrollToPage (page) {
            const container = this.$refs.contentContainer
            const scrollAmount = page * (this.itemsPerPage * (container.clientWidth / 6))
            container.scrollTo({ left: scrollAmount, behavior: 'smooth' })
        },
        showPrev () {
            if (this.currentPage > 0) {
                this.currentPage--
                this.scrollToPage(this.currentPage)
            }
        },
        showNext () {
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++
                this.scrollToPage(this.currentPage)
            }
        }
    }
}
